import { DateOption } from '../api';

export const getLimitRemaining = (
    selectedDate: DateOption | undefined,
    twoWeekLimitRemaining: number
) =>
    selectedDate
        ? Math.min(selectedDate.daily_limit_remaining, twoWeekLimitRemaining)
        : twoWeekLimitRemaining;
